import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationSection from './components/LocationSection';
import ServicesSection from '../../home/components/ServicesSection';
import BenefitsSection from '../../home/components/BenefitsSection';
import TintShadesSection from '../../home/components/TintShadesSection';
import TestimonialsSection from '../../home/components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from '../../home/components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../../utils/seo';
import { useEffect } from 'react';

export default function GlenBurniePage() {
  // Apply localized SEO metadata with geo-tags
  useSEO({
    title: 'Glen Burnie Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
    description:
      'Professional window tinting services in Glen Burnie, Maryland. Expert ceramic tint installation, mobile service, commercial tinting, vehicle decals, and headlight tinting. Serving Glen Burnie, Pasadena, Severna Park. Lifetime warranty. Call (443) 800-0348.',
    keywords:
      'window tinting Glen Burnie, ceramic tint Glen Burnie MD, mobile tinting Glen Burnie, commercial tinting Glen Burnie, vehicle decals Glen Burnie',
    canonical: '/locations/glen-burnie',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateLocalBusinessSchema(),
          '@type': 'AutoRepair',
          name: 'U.B.K Window Tint - Glen Burnie',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: 'Glen Burnie',
            addressRegion: 'MD',
            postalCode: '21061',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '39.1626',
            longitude: '-76.6247',
          },
          areaServed: {
            '@type': 'City',
            name: 'Glen Burnie',
            '@id': 'https://en.wikipedia.org/wiki/Glen_Burnie,_Maryland',
          },
        },
        generateWebPageSchema(
          'Glen Burnie Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
          'Professional window tinting services in Glen Burnie, Maryland with lifetime warranty and same-day service.',
          '/locations/glen-burnie'
        ),
      ],
    },
  });

  useEffect(() => {
    // Add geo meta tags for local SEO
    const geoTags = [
      { name: 'geo.region', content: 'US-MD' },
      { name: 'geo.placename', content: 'Glen Burnie' },
      { name: 'geo.position', content: '39.1626;-76.6247' },
      { name: 'ICBM', content: '39.1626, -76.6247' },
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">
          Glen Burnie Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint
        </h1>
      </header>
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
